import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getArchivedProjectsOfBusiness = async (activeEmployerInfo) => {
  const { activeEmployerBusinessId } = activeEmployerInfo;

  const apiPath = `projects/business/${activeEmployerBusinessId}/archived-projects`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
